import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=ed399834&lang=pug&"
import script from "./alert.vue?vue&type=script&lang=js&"
export * from "./alert.vue?vue&type=script&lang=js&"
import style0 from "./alert.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed399834')) {
      api.createRecord('ed399834', component.options)
    } else {
      api.reload('ed399834', component.options)
    }
    module.hot.accept("./alert.vue?vue&type=template&id=ed399834&lang=pug&", function () {
      api.rerender('ed399834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/prototype/alert.vue"
export default component.exports